var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlueQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M0 38.168c0-5.743 1.972-11.84 5.917-18.287 3.999-6.503 11.186-12.436 21.56-17.8l1.946 3.657c-5.188 3.685-9.024 6.773-11.51 9.266-4.377 4.497-6.565 8.805-6.565 12.923 0 1.409.405 2.33 1.215 2.764.811.487 1.513.731 2.108.731 2.053-.27 3.404-.406 4.053-.406 3.458 0 6.295 1.273 8.51 3.82 2.216 2.492 3.324 5.527 3.324 9.103 0 4.01-1.216 7.37-3.648 10.078C24.48 56.672 21.128 58 16.86 58c-5.026 0-9.106-1.788-12.24-5.364C1.54 49.006 0 44.183 0 38.168zm36.442-2.08c0-6.07 2.108-12.328 6.323-18.776C46.979 10.864 54.03 5.093 63.92 0l1.945 3.658c-4.863 3.413-8.592 6.42-11.185 9.021-4.593 4.606-6.89 8.887-6.89 12.842 0 1.138.297 2.06.892 2.764.594.704 1.404 1.056 2.431 1.056 2.054-.27 3.404-.406 4.053-.406 3.404 0 6.214 1.246 8.43 3.739C65.866 35.166 67 38.228 67 41.858c0 4.227-1.243 7.64-3.728 10.241-2.486 2.547-5.864 3.82-10.132 3.82-4.864 0-8.862-1.788-11.996-5.364-3.135-3.63-4.702-8.453-4.702-14.468z",
    fill: "#0085FF"
  })));
}

export default SvgBlueQuote;